"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURE_FLAGS = exports.FEATURE_FLAGS_PER_APP = exports.FEATURE_FLAG_API_BASE_URL = void 0;
/**
 * Base API for feature flags
 */
exports.FEATURE_FLAG_API_BASE_URL = '/feature-flags/api';
/**
 * Mapping of the different feature flags for the different apps
 * Add new properties for a new app or feature flags created as needed
 * Make sure to add any new feature flag created to the FEATURE_FLAGS enum in this same file
 */
exports.FEATURE_FLAGS_PER_APP = {
    'assess-web-teacher-app': {
        MONITOR_CONNECTED_STUDENTS: 'AssessWebTeacherApp.monitorConnectedStudents',
    },
    'assess-web-student-app': {
        MONITOR_CONNECTED_STUDENTS: 'AssessWebTeacherApp.monitorConnectedStudents',
    },
};
/**
 * Existing feature flags
 */
var FEATURE_FLAGS;
(function (FEATURE_FLAGS) {
    FEATURE_FLAGS["MONITOR_CONNECTED_STUDENTS"] = "MONITOR_CONNECTED_STUDENTS";
})(FEATURE_FLAGS || (exports.FEATURE_FLAGS = FEATURE_FLAGS = {}));
